import { getVariantContent } from '@pcln/contentful-components'
import useSeti from './useSeti'

export default function useContent(item: any, shouldFireImpression = true) {
  const setiName = useSeti(
    item?.experimentName,
    shouldFireImpression && item?.experimentName !== undefined
  )
  return item?.experimentName ? getVariantContent(setiName, item) : item
}
